import {Routes} from "@angular/router";
import {ContactComponent} from "./contact.component";

export const contactRoutes: Routes = [
  {path: '', component: ContactComponent}
];
